var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/text-icon.7c62b5fc.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 3.8H13.1333C14.1651 3.8 15 4.6349 15 5.66667V10.8M2.02083 7.53333H7.32917M1 10.8V10.6833L4.23385 1H5.25104L8.46667 10.6833V10.8M13.2937 10.3333H11.2667C10.7526 10.3333 10.3333 9.91406 10.3333 9.4V7.53333C10.3333 7.01927 10.7526 6.6 11.2667 6.6H14.0667C14.5807 6.6 15 7.01927 15 7.53333V9.4L14.6135 9.78646C14.2635 10.1365 13.7896 10.3333 13.2937 10.3333Z",
    stroke: "#8698A5",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.2ebb6aa3491c8b9f995b5c135067c5c2.svg";
export { ForwardRef as ReactComponent };